import { Component, Input, OnInit, SimpleChanges, ViewChild, ElementRef, Output, EventEmitter } from '@angular/core';
import * as _ from 'lodash';

@Component({
    selector: 'modal-item-apportionment',
    templateUrl: './modal-item-apportionment.component.html',
    styleUrls: ['../../billing-letter-edit/billing-letter-edit.component.scss']
})
export class ModalItemApportiApportionmentComponent implements OnInit {
    @ViewChild("buttonCloseModalParcel") buttonCloseModalParcel: ElementRef;
    @Input() showModalApportionment: boolean;
    @Input() isParcelApportionment: boolean;
    @Input() canEdit: boolean;
    @Input() objectApportionment: any;
    @Output() closeModalItemApportionment: EventEmitter<boolean> = new EventEmitter();

    objApportionment: any;
    refundsToUpdate = [];
    parcelIndexAddRefund: number = -1;
    refundsDropdown = {
        list: [],
        options: null,
        selected: []
    };
    apportionment: any;
    whichModalIsOpen: string = '';
    isModalOpen: boolean = false;

    constructor() {}

    async ngOnInit() {
    }

    modalLayer(modalType: string) {
        return modalType
    }

    async ngOnChanges(changes: SimpleChanges) {
    }

    getValuePartial(object){
        if(!object) return 0;
        let sumProject = object.project.reduce((acc, { value }) => acc + value, 0);
        let sumProduct = object.product.reduce((acc, { value }) => acc + value, 0);
        let sumRefund = object.refund.reduce((acc, { value }) => acc + value, 0);
        return object.value - sumProduct - sumProject - sumRefund;
    }

    removeRefund(refundId) {
        let refundListAux = this.objectApportionment.refund;
        let refundAux = refundListAux.find(refund => refund._id === refundId);
        refundListAux = refundListAux.filter(refund => refund._id !== refundId);

        this.objectApportionment.refund = refundListAux;
        this.refundsDropdown.list.push({
            id: refundAux._id,
            itemName: refundAux.name,
            value: refundAux.value,
        });
        this.refundsToUpdate = this.refundsToUpdate.filter(refund => refund._id !== refundAux._id);
    }

    setParcelIndexToAddRefund(i) {
        this.parcelIndexAddRefund = parseInt(i);
    }

    closeModal() {
        this.closeModalItemApportionment.emit(true);
    }

    sendModalApportionment() {
        this.toogleModal('rateioModal')
        let industry = this.objectApportionment.industry ? [this.objectApportionment.industry] : this.objectApportionment.company && this.objectApportionment.company.industry ? [this.objectApportionment.company.industry] : [];
        this.apportionment = {
            industries: industry,
            excellenceCenters: this.objectApportionment.excellenceCenters,
            supportCenters: this.objectApportionment.supportCenters
        }
    }

    getModalApportionment(apportionment) {
        let excellenceCenters = apportionment.excellenceCenters.filter(excellenceCenter => excellenceCenter.percentage > 0);
        let supportCenters = apportionment.supportCenters.filter(supportCenter => supportCenter.percentage > 0);

        this.objectApportionment.excellenceCenters = excellenceCenters.map(excellenceCenter => {
            return {
                ...excellenceCenter,
                value: this.contPercentage(this.objectApportionment.value, excellenceCenter.percentage)
            };
        });

        this.objectApportionment.supportCenters = supportCenters.map(supportCenter => {
            return {
                ...supportCenter,
                value: this.contPercentage(this.objectApportionment.value, supportCenter.percentage)
            };
        });
    }

    contPercentage(value, percentage) {
        return (value * percentage) / 100;
    }

    toogleModal(modalId: string, isRatioModalClosed = false): void {
        const modal = document.getElementById(modalId)
        this.whichModalIsOpen = modalId;
        if (modal.style.display === "none") {
            modal.style.display = "block"
            this.isModalOpen = false;
        } else {
            modal.style.display = "none"
            this.isModalOpen = true;
        }

        if (modalId == 'rateioModal' && isRatioModalClosed) {
            this.whichModalIsOpen = 'modalParcels';
            this.isModalOpen = true;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/billing-letter/components/modal-item-apportionment/modal-item-apportionment.component.ts